import { NavLink } from 'react-router-dom';
import React from 'react';

import useActivePage from '../../hooks/active-page';
import { NotFoundWrapper } from './styled';

const NotFound = () => {
  const activePage = useActivePage();
  
  // Surprisingly, this page overlaps (loads on) other pages
  // The line below controls the overlap.
  if (activePage.name !== 'PageNotFound') return null;

  return (
    <NotFoundWrapper>
      <NavLink to="/" className="logo">
        <img src="/static/images/logo/formplus-logo.png" alt="Formplus" />
      </NavLink>

      <section>
        <div className="top">
          <img src="https://storage.googleapis.com/fplsblog/404-desktop.svg" alt="404_icon" />
          
          <p>It seems this page doesn’t exist</p>
        
          <NavLink to="/">Go to Homepage</NavLink>
        </div>

        <div className="bottom">
          <a href="https://www.formpl.us/form/926396118">
            Talk to Support
          </a>
        </div>
      </section>
    </NotFoundWrapper>
  );
};

export default NotFound;